export type UserServiceResponse = UserServiceEmailResponse | UserServiceMobileNumberResponse;

export interface UserServiceEmailResponse {
  email_verified: boolean;
  email: string;
}

export interface UserServiceMobileNumberResponse {
  customerId: string;
}

export const isEmailResponseType = (
  response: UserServiceResponse,
): response is UserServiceEmailResponse => {
  return response.hasOwnProperty('email');
};
